import { createContext } from 'react'

export type MapType = 'hybrid' | 'roadmap' | 'terrain' | 'satellite' | 'streetView'
export type MapProvider = 'google' | 'mapbox'

export const MapContext = createContext<{
  mapProvider: MapProvider
  mapType: MapType | undefined
  is3D: boolean
} | null>(null)
